import { Link } from 'react-router-dom';
import { _t } from '@/i18n/t';

import type { MenuItem } from './types';

type Props = {
  item: MenuItem;
  isCollapsed: boolean;
  selected: boolean;
};

const itemClasses = (selected: boolean) =>
  `group relative flex items-center h-[34px] text-nav-item transition-colors ${
    selected
      ? 'bg-nav-activeBg text-nav-text-selected font-medium'
      : 'text-nav-text hover:bg-nav-activeBg'
  }`;

const SidebarItem = ({ item, isCollapsed, selected }: Props) => {
  const label = _t(item.labelKey);

  return (
    <Link
      to={item.path}
      className={itemClasses(selected)}
      aria-current={selected ? 'page' : undefined}
      title={isCollapsed ? label : undefined}
    >
      {!isCollapsed && selected && <span className="absolute left-0 inset-y-0 my-auto h-nav-active-bar w-0.5 rounded-r-full bg-nav-activeIndicator" />}
      <div className={`flex items-center gap-3 ${isCollapsed ? 'w-full justify-center px-0' : 'px-4'}`}>
        <item.icon className="h-nav-icon w-nav-icon flex-shrink-0 text-nav-icon group-hover:text-current" />
        {!isCollapsed && <span>{label}</span>}
      </div>
    </Link>
  );
};

export default SidebarItem;
